import axios from "axios";
import router from "../router/index";
import {
  message
} from "./resetMessage"; // 引入重写element的提示弹窗

const service = axios.create({
  baseURL: "",
  timeout: 15000 * 12 * 3,
});

// 请求前附令牌
service.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      lrmv2token: sessionStorage.getItem("lrmv2token"), // 附令牌到请求头
    };
    // config.headers.lrmv2_token = sessionStorage.getItem("lrmv2_token"); // 附令牌到请求头
    // if (config.formData) {
    //   config.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
    //   console.log("sddsasddas", config);
    // }
    if (!config.formData) {
      config.data = {
        data: config.data || {},
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截
service.interceptors.response.use(
  (response) => {
    // console.log("状态码不是200", response);
    if (response.config.method == "get") {
      if (response.status === 200) {
        return response.data;
      }
      return Promise.reject(response.data);
    }
    if (response.config.method == "post") {
      if (response.data.code === 200) {
        return response.data;
      }
      if (response.data.code === 401 || response.data.code === 403) {
        // token过期重定向到登录页面
        if (
          sessionStorage.getItem("selectMenu") &&
          JSON.parse(sessionStorage.getItem("selectMenu")).path
        ) {
          sessionStorage.setItem(
            "tagsList",
            JSON.stringify([JSON.parse(sessionStorage.getItem("selectMenu"))])
          );
        }
        router.replace({
          path: "/",
          query: {
            redirect: router.currentRoute.fullPath,
          },
        });
      } else if (response.data.code === 406) {
        message.error(response.data.message);
      } else if (response.data.code === -1) {
        message.error(response.data.message);
        return response.data;
      } else if (response.data.code === 0) {
        message.error(response.data.message);
        return response.data;
      } else if (response.data.code === 404) {
        return Promise.reject(response.data);
      } else {
        // message.error("请求失败！");
        return response.data
      }
    }
  },
  (error) => {
    message.error("请求超时！");
    return Promise.reject({
      code: 1030,
      message: "请求失败！"
    });
  }
);

export default service;
